import React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { Chip } from "@mui/material";
import { Icon } from "@iconify/react";

const JobsList = ({ jobs }) => {
  return (
    <Box>
      <Stepper
        orientation="vertical"
        activeStep={-1}
        nonLinear
        sx={{
          "& .MuiStepIcon-root": {
            color: "primary.main",
          },
          "& .Mui-completed .MuiStepIcon-root": {
            color: "primary.main",
          },
        }}
      >
        {jobs.map((job) => (
          <Step key={job.goal_job_id} expanded>
            <StepLabel>
              <Box sx={{ display: "flex", flexDirection: "row", gap: 0.5 }}>
                <Typography
                  sx={{
                    textDecoration:
                      job.goal_job_striked === 1 ? "line-through" : "none",
                  }}
                >
                  {job.goal_job_name}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {job.goal_job_striked === 1 ? (
                    <Chip
                      size="small"
                      sx={{
                        height: 15,
                        fontSize: "0.6rem",
                        backgroundColor: "#ffe4de",
                        color: "#b71d18",
                      }}
                      icon={
                        <Icon
                          color="error"
                          icon="fluent:delete-48-regular"
                          width="13"
                          height="13"
                        />
                      }
                      variant="contained"
                      label={`Deleted`}
                    />
                  ) : null}
                  {job.goal_job_striked === 0 ? (
                    <Chip
                      size="small"
                      sx={{
                        height: 15,
                        fontSize: "0.6rem",
                        backgroundColor:
                          job.goal_job_completed === 1 ? "#dbf6e5" : "#fff1d6",
                        color:
                          job.goal_job_completed === 1 ? "#119272" : "#b76e00",
                      }}
                      icon={
                        job.goal_job_completed === 1 ? (
                          <Icon
                            color="success"
                            icon="fluent:checkmark-48-regular"
                            width="13"
                            height="13"
                          />
                        ) : (
                          <Icon icon="mdi-light:clock" width="13" height="13" />
                        )
                      }
                      variant="contained"
                      label={
                        job.goal_job_completed === 1 ? `Completed` : `Pending`
                      }
                    />
                  ) : null}
                </Box>
              </Box>
            </StepLabel>
            <StepContent>
              <Chip
                size="small"
                sx={{ height: 15, fontSize: "0.6rem", mr: 0.5 }}
                icon={
                  <Icon icon="stash:data-date-light" width="15" height="15" />
                }
                variant="contained"
                label={`Start-${job.goal_job_start_date || "No Start Date"}`}
              />
              <Chip
                size="small"
                sx={{ height: 15, fontSize: "0.6rem" }}
                icon={
                  <Icon icon="stash:data-date-light" width="15" height="15" />
                }
                variant="contained"
                label={`End-${job.goal_job_end_date || "No End Date"}`}
              />
            </StepContent>
          </Step>
        ))}
      </Stepper>

      {jobs.length === 0 && (
        <Paper square elevation={0} sx={{ p: 3 }}>
          <Typography>No jobs available.</Typography>
        </Paper>
      )}
    </Box>
  );
};

export default JobsList;
